export default __webpack_public_path__ + "static/media/knowMore1.c68b9a92.png";